<template>
    <a-modal centered :visible="visible" :title="$t('Add/Edit') + ' ' + $t('Procurement Step')" @cancel="cancel">
        <a-form layout="vertical" :form="form">
            <div class="row">
                <div class="col-lg-12 center">
                    <div class="row">
                        <label class="col-sm-3 col-form-label text-right">{{ $t('Code') }}</label>
                        <div class="col-lg-7">
                            <a-form-item>
                                <a-input
                                    v-decorator="[
                                        'code',
                                        {
                                            initialValue: data_by_id.code,
                                            rules: [{ required: true, message: 'Please input code!' }],
                                        },
                                    ]"
                                />
                            </a-form-item>
                        </div>
                    </div>
                    <div class="row">
                        <label class="col-sm-3 col-form-label text-right">{{ $t('Procurement Step Name') }}</label>
                        <div class="col-lg-7">
                            <a-form-item>
                                <a-input
                                    v-decorator="[
                                        'name',
                                        {
                                            initialValue: data_by_id.name,
                                            rules: [
                                                {
                                                    required: true,
                                                    message: 'Please input procurement type name!',
                                                },
                                            ],
                                        },
                                    ]"
                                />
                            </a-form-item>
                        </div>
                    </div>
                    <div class="row">
                        <label class="col-sm-3 col-form-label text-right">{{ $t('ประมาณการเวลาทำงาน (วัน)') }}</label>
                        <div class="col-lg-7">
                            <a-form-item>
                                <a-input
                                    v-decorator="[
                                        'estimate_day',
                                        {
                                            initialValue: data_by_id.estimate_day,
                                            rules: [
                                                {
                                                    required: true,
                                                    message: 'Please input estimate day!',
                                                },
                                            ],
                                        },
                                    ]"
                                />
                            </a-form-item>
                        </div>
                    </div>
                    <div class="row">
                        <label class="col-sm-3 col-form-label text-right">{{ $t('Status') }}</label>
                        <div class="col-lg-7">
                            <a-form-item>
                                <a-select
                                    v-decorator="[
                                        'status',
                                        {
                                            initialValue: (data_by_id && data_by_id.status && Number(data_by_id.status)) || 0,
                                            rules: [{ required: true, message: 'Please select Status!' }],
                                        },
                                    ]"
                                >
                                    <a-select-option v-bind:value="0">{{ $t('All') }}</a-select-option>
                                    <a-select-option v-bind:value="1">{{ $t('active') }}</a-select-option>
                                    <a-select-option v-bind:value="2">{{ $t('in-active') }}</a-select-option>
                                </a-select>
                            </a-form-item>
                        </div>
                    </div>
                </div>
            </div>
        </a-form>
        <template slot="footer">
            <a-button key="back" type="danger" @click="cancel()">{{ $t('Cancel') }}</a-button>
            <a-button key="submit" type="primary" @click="create()">{{ $t('Save') }}</a-button>
        </template>
    </a-modal>
</template>
<script>
export default {
    props: ['visible', 'data_by_id'],
    beforeCreate() {
        this.form = this.$form.createForm(this, { name: 'form_in_modal' });
    },
    data() {
        return {};
    },
    methods: {
        cancel() {
            this.$emit('on-cancel');
        },
        create() {
            this.$emit('on-save');
        },
    },
};
</script>